var map = {
	"./gameplay-chainspin-small.webp": [
		38155,
		38155
	],
	"./gameplay-chokwin-small.webp": [
		8287,
		8287
	],
	"./gameplay-flashsportscasino-small.webp": [
		37417,
		37417
	],
	"./gameplay-gannar-small.webp": [
		54290,
		54290
	],
	"./gameplay-luckykingbet-small.webp": [
		82533,
		82533
	],
	"./gameplay-mars-br-small.webp": [
		71673,
		71673
	],
	"./gameplay-mars-es-small.webp": [
		61185,
		61185
	],
	"./gameplay-mars-mx-small.webp": [
		28545,
		28545
	],
	"./gameplay-mars-pt-small.webp": [
		97660,
		97660
	],
	"./gameplay-mars-ru-small.webp": [
		93468,
		93468
	],
	"./gameplay-mars-small.webp": [
		9018,
		9018
	],
	"./gameplay-mars-th-small.webp": [
		24128,
		24128
	],
	"./gameplay-novero-small.webp": [
		10554,
		10554
	],
	"./gameplay-rollblock-small.webp": [
		22681,
		22681
	],
	"./gameplay-zenginsin-small.webp": [
		47749,
		47749
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 14282;
module.exports = webpackAsyncContext;